var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C8.5 16 0 10.9091 0 4.72728C0 3.63445 0.35402 2.57537 1.00183 1.73024C1.64964 0.885109 2.55121 0.306129 3.55317 0.0918078C4.55512 -0.122514 5.59556 0.0410625 6.49745 0.554706C7.39935 1.06835 8.107 1.90033 8.5 2.9091C8.893 1.90033 9.60065 1.06835 10.5025 0.554706C11.4044 0.0410625 12.4449 -0.122514 13.4468 0.0918078C14.4488 0.306129 15.3504 0.885109 15.9982 1.73024C16.646 2.57537 17 3.63445 17 4.72728C17 10.9091 8.5 16 8.5 16Z",
    fill: "#01313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularActive);
export default __webpack_public_path__ + "static/media/popular-active.966a54b8097626f879c2ad2c602473b6.svg";
export { ForwardRef as ReactComponent };